// extracted by mini-css-extract-plugin
module.exports = {"CardContact":"Contact_CardContact__pRPLo","Contact":"Contact_Contact__1CvVj","WhatsappMovile":"Contact_WhatsappMovile__2CKUb","WhatsappDesktop":"Contact_WhatsappDesktop__3jk54"};